import { useCallback, useEffect, useState } from "react";
import { messageService } from "@/services/message.service";

const UNREAD_MESSAGES_EVENT = "unread-messages-refresh";

export const notifyUnreadMessagesChanged = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(UNREAD_MESSAGES_EVENT));
  }
};

export function useUnreadMessages(enabled: boolean) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const refreshUnreadMessages = useCallback(async () => {
    if (!enabled) {
      setUnreadCount(0);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    try {
      const count = await messageService.getUnreadCount();
      setUnreadCount(count);
    } catch (error) {
      console.error("Failed to load unread message count", error);
    } finally {
      setIsLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    void refreshUnreadMessages();
  }, [refreshUnreadMessages]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const handleRefresh = () => {
      void refreshUnreadMessages();
    };
    window.addEventListener(UNREAD_MESSAGES_EVENT, handleRefresh);
    return () => window.removeEventListener(UNREAD_MESSAGES_EVENT, handleRefresh);
  }, [refreshUnreadMessages]);

  return {
    unreadCount,
    isLoading,
    refreshUnreadMessages,
  };
}
